import { defineStore } from 'pinia';
import { ref } from 'vue';
import type { Ref } from 'vue';
import type { Category } from '@/resources/types';
import { useNuxtApp } from '#imports';
export const useCategoryStore = defineStore('category', () => {
  const { $logger } = useNuxtApp();
  const categoriesLoading: Ref<boolean> = ref(false);
  const categories: Ref<Category[]> = ref([]);

  async function fetchCategories() {
    categoriesLoading.value = true;
    try {
      const { results } = await $fetch('/api/tyk/categories');
      categories.value =
        results
          ?.filter((obj: Category) => obj && obj.enabled === 1)
          .sort((a: Category, b: Category) => {
            return a.name.localeCompare(b.name);
          }) || [];
    } catch (e) {
      throw new Error('Failed to fetch categories.');
    } finally {
      categoriesLoading.value = false;
    }
  }

  return {
    categories,
    categoriesLoading,
    fetchCategories
  };
});